import Swiper, { A11y, EffectFade } from 'swiper';

import '../../sass/blocks/text-image-columns.scss';

(() => {
    const $textImageColumns = document.querySelectorAll('.text-image-columns');

    if (!$textImageColumns) return;

    const sliders = [];

    $textImageColumns.forEach($textImageColumns => {
        const $sliders = $textImageColumns.querySelectorAll('.text-image-columns__text-block-slider');

        const initCarousels = () => {
            if (!$sliders) return;

            $sliders.forEach($slider => {
                const $carouselSlides = $slider.querySelectorAll('.swiper-slide');

                if ($carouselSlides.length <= 1) return;
        
                const slider = new Swiper($slider, {
                    modules: [ A11y, EffectFade ],
                    effect: 'fade',
                    allowTouchMove: false,
                });

                sliders.push(slider);
            });
        };

        initCarousels();
    });

    const initSliderAutoplay = () => {
        if (!sliders) return;

        setInterval(() => {
            sliders.forEach(slider => {
                slider.slideNext();
            });
        }, 4000);
    };

    initSliderAutoplay();
})();
